import React, { useState, useRef, useEffect, useCallback } from "react";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CommonContainer from "../Container/CommonContainer";
import { Calendar, Eye } from "lucide-react";
import ReactDatePicker from "react-datepicker";
import toast from "react-hot-toast";
import "react-datepicker/dist/react-datepicker.css";
import { formatVisitDate } from "../../Common/CommonVariables";
import * as CommonVariables from "../../Common/CommonVariables";
import { useLocation } from "react-router-dom";
import * as RegistrationStatusReportService from "../../Services/MHL_Reports/RegistrationStatusReportService";
import {
  FaSearch,
  FaSpinner,
  FaInfoCircle,
  FaFileCode,
  FaPaperPlane,
  FaEye,
} from "react-icons/fa";
import Popover from "../../Common/Popper";
import CommonPagination from "../../Common/CommonPagination";
import Editor from "@monaco-editor/react";
import * as TRFListRegistrationService from "../../Services/B2BRegistration/TRFListRegistrationService";
import * as B2BRegistrationService from "../../Services/B2BRegistration/B2BRegistrationService";
import { store } from "../../Store/store";

const RegistrationStatusComponent = () => {
  const userInfo = store.getState();
  const userDetails = userInfo?.userData || {};

  const [registrationStatusList, setRegistrationStatusList] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [SearchLoading, setSearchLoading] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [dateRangeOption, setDateRangeOption] = useState("Today");
  const [searchData, setSearchData] = useState("");
  const [jsonType, setJsonType] = useState("");
  const [selectedTrfStatusId, setSelectedTrfStatusId] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [initDone, setInitDone] = useState(false);
  const [b2bTRFRegistrationDetails, setB2BTRFRegistrationDetails] = useState(
    [],
  );
  const [showPreview, setShowPreview] = useState(false);
  const [selectedTest, setSelectedTest] = useState([]);
  const [showAttachments, setShowAttachments] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [editorMode, setEditorMode] = useState("VIEW");
  const [trfReq, setTrfReq] = useState("");
  const [rniReq, setRniReq] = useState("");
  const [loading, setLoading] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Set number of items per page

  // Pagination logic
  const indexOfLastRegistration = currentPage * itemsPerPage;
  const indexOfFirstRegistratio = indexOfLastRegistration - itemsPerPage;
  const currentRegistrations = registrationStatusList.slice(
    indexOfFirstRegistratio,
    indexOfLastRegistration,
  );

  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const filterDropdownRef = useRef(null);

  const location = useLocation();

  useEffect(() => {
    if (!initDone && location.state) {
      const {
        startDate: passedStartDate,
        endDate: passedEndDate,
        dateRangeOption: passedOption,
      } = location.state;

      if (passedStartDate && endDate) {
        setDateRangeOption(passedOption || "Custom");
        setStartDate(new Date(passedStartDate));
        setEndDate(new Date(passedEndDate));
        setInitDone(true); // Prevents re-running this logic
      }
    }
  }, [location.state, initDone]);

  useEffect(() => {
    if (initDone && startDate && endDate) {
      fetchRegistrationStatusList();
    }
  }, [initDone, startDate, endDate, dateRangeOption]);

  useEffect(() => {
    if (startDate && endDate) {
      fetchRegistrationStatusList();
    }
  }, [dateRangeOption]);

  const formatDate = (date, endOfDay = false) => {
    if (!date) return null;
    const d = new Date(date);
    if (endOfDay) {
      d.setHours(23, 59, 59, 999);
    } else {
      d.setHours(0, 0, 0, 0);
    }
    return d.toISOString();
  };

  const fetchRegistrationStatusList = useCallback(() => {
    if (dateRangeOption === "Custom") {
      if (!startDate || !endDate) {
        toast.error(
          "Please select both Start Date and End Date for Custom range",
        );
        return;
      }
    }

    if (startDate > endDate) {
      toast.error("Start date cannot be after end date");
      return;
    }

    if (endDate > new Date()) {
      toast.error("End date cannot be of future");
      return;
    }

    setSearchLoading(true);

    const payload = {
      StartDate: formatDate(startDate),
      EndDate: formatDate(endDate, true),
    };

    RegistrationStatusReportService.RegistrationStatusReport(payload)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setRegistrationStatusList(data.Data);
        } else {
          setRegistrationStatusList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => {
        setSearchLoading(false);
      });
  }, [startDate, endDate, dateRangeOption]);

  const getRegistrationListBySearch = () => {
    setSearchLoading(true);
    setCurrentPage(1);
    RegistrationStatusReportService.GetRegistrationListBySearch(searchData)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setRegistrationStatusList(data.Data);
        } else {
          setRegistrationStatusList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setSearchLoading(false));
  };

  const handleAttachmentDownload = (url) => {
    if (!url) {
      toast.error("No file URL provided.");
      return;
    }
    B2BRegistrationService.View_UploadedFile(url)
      .then(({ data }) => {
        if (data.IsSuccess) {
          //debugger;
          // window.open(data.Data, '_blank');
          const newWindow = window.open(data.Data, "_blank");
          if (newWindow) {
            newWindow.focus();
            newWindow.print();
          }
        } else {
          toast.error("Failed to download file.");
        }
      })
      .catch(() => toast.error("Something went wrong while downloading."));
  };

  const GetB2BTRFRegistrationDetailByTRFId = (trfId) => {
    setSearchLoading(true);
    TRFListRegistrationService.GetB2BTRFRegistrationDetailByTRFId(trfId)
      .then(({ data }) => {
        //debugger;
        if (data.IsSuccess) {
          setB2BTRFRegistrationDetails(data.Data);
          setShowPreview(true);
        } else {
          setB2BTRFRegistrationDetails([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setSearchLoading(false));
  };

  const RepushFailedRegistration = (trfId) => {
    setSearchLoading(true);

    TRFListRegistrationService.RepushFailedRegistration(trfId)
      .then(({ data }) => {
        if (data.IsSuccess) {
          fetchRegistrationStatusList();
          toast.success(data.ResponseMessage);
        } else {
          // setB2BTRFRegistrationDetails([])
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setSearchLoading(false));
  };

  const handleDateRangeChange = (e) => {
    const selected = e.target.value;
    setDateRangeOption(selected);

    const today = new Date();
    let start = null;
    let end = null;

    switch (selected) {
      case "Today":
        start = new Date();
        end = new Date();
        break;
      case "Yesterday":
        start = new Date();
        start.setDate(start.getDate() - 1);
        end = new Date(start);
        break;
      case "Current Week":
        start = new Date();
        start.setDate(start.getDate() - start.getDay());
        end = new Date();
        break;
      case "Last 7 Days":
        start = new Date();
        start.setDate(start.getDate() - 6);
        end = new Date();
        break;
      case "MTD":
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = new Date();
        break;
      case "Last 30 Days":
        start = new Date();
        start.setDate(start.getDate() - 29);
        end = new Date();
        break;
      case "Custom":
        start = null;
        end = null;
        break;
      default:
        break;
    }

    setStartDate(start);
    setEndDate(end);
  };

  useEffect(() => {
    if (!showFilter) return;

    const handleClickOutside = (event) => {
      if (
        filterDropdownRef.current &&
        !filterDropdownRef.current.contains(event.target)
      ) {
        setShowFilter(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showFilter]);

  const openModal = (jsonString, type, mode, trfStatusId) => {
    if (!jsonString || typeof jsonString !== "string") {
      toast.error("No JSON available to display");
      return;
    }

    let formatted = "";
    try {
      formatted = JSON.stringify(JSON.parse(jsonString), null, 2);
    } catch {
      formatted = jsonString;
    }

    setEditorMode(mode);
    setJsonType(type);
    setModalContent(formatted);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setShowPreview(false);
    // setModalContent("");
  };

  const handleSave = () => {
    if (jsonType === "Trf_Req") {
      const payload = {
        Trf_Status_Id: selectedTrfStatusId,
        Updated_Trf_Req_Json: modalContent,
      };

      RegistrationStatusReportService.UpdateTrfRequest(payload)
        .then(({ data }) => {
          if (data.IsSuccess) {
            setIsModalOpen(false);
            setShowPreview(false);
            toast.success(data.ResponseMessage);
          } else {
            toast.error(data.ResponseMessage);
          }
        })
        .catch(() => toast.error("Something went wrong")).finally(()=>setLoading(false));
    }

    if (jsonType === "Rni_Req") {
      const payload = {
        Trf_Status_Id: selectedTrfStatusId,
        Updated_Rni_Req_Json: modalContent,
      };

      RegistrationStatusReportService.UpdateRniRequest(payload)
        .then(({ data }) => {
          if (data.IsSuccess) {
            setIsModalOpen(false);
            setShowPreview(false);
            toast.success(data.ResponseMessage);
          } else {
            toast.error(data.ResponseMessage);
          }
        })
        .catch(() => toast.error("Something went wrong")).finally(()=>setLoading(false));
    }
  };

  return (
    <>
      <CommonContainer heading="Registration Status">
        <div className="d-flex flex-column flex-lg-row justify-content-between">
          <div className="d-flex flex-column flex-lg-row gap-2 justify-content-between mb-2">
            <div className="d-flex flex-column flex-md-row gap-1 align-items-md-center">
              <select
                className="form-select patient-visit-form-select mb-2 mb-md-0"
                style={{ maxWidth: "200px" }}
                value={dateRangeOption}
                onChange={handleDateRangeChange}
              >
                <option value="Today">Today</option>
                <option value="Yesterday">Yesterday</option>
                <option value="Current Week">Current Week</option>
                <option value="Last 7 Days">Last 7 Days</option>
                <option value="MTD">MTD</option>
                <option value="Last 30 Days">Last 30 Days</option>
                <option value="Custom">Custom</option>
              </select>

              {dateRangeOption === "Custom" && (
                <>
                  <div className="position-relative mb-2 mb-md-0">
                    <ReactDatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                      placeholderText="Select Start Date"
                      ref={startDateRef}
                    />
                    <Calendar
                      size={20}
                      className="position-absolute "
                      style={{
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                      onClick={() => startDateRef.current.setFocus()}
                    />
                  </div>

                  <div className="position-relative mb-2 mb-md-0">
                    <ReactDatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      className="form-control mobile-style"
                      dateFormat="dd-MM-yyyy"
                      placeholderText="Select End Date"
                      ref={endDateRef}
                    />
                    <Calendar
                      size={20}
                      className="position-absolute"
                      style={{
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                      onClick={() => endDateRef.current.setFocus()}
                    />
                  </div>
                </>
              )}

              <div className="d-flex gap-1 align-items-center">
                <button
                  className="btn custom-sumbitbtn d-flex align-items-center justify-content-center patient-visit-search-btn"
                  // style={{ height: "35px", padding: "0" }}
                  onClick={fetchRegistrationStatusList}
                  disabled={SearchLoading}
                >
                  {SearchLoading ? (
                    <FaSpinner className="fa-spin" />
                  ) : (
                    <b>GO</b>
                  )}
                </button>
              </div>

              <div className="my-2">
                {SearchLoading ? <CommonVariables.LoadingMessage /> : null}
              </div>
            </div>
          </div>

          <div
            className="search-box patient-visit-search-box"
            style={{ position: "relative", width: "320px" }}
          >
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search by TRF ID & Partner Code"
                value={searchData}
                onChange={(e) => setSearchData(e.target.value)}
                // ref={selectedSearchPR}
                style={{
                  paddingRight: "35px",
                  borderRadius: "5px",
                  border: "1px solid #ddd",
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    getRegistrationListBySearch();
                  }
                }}
              />
              <button
                className="btn custom-sumbitbtn d-flex align-items-center justify-content-center patient-visit-search-box-search-btn"
                style={{
                  padding: "5px",
                  position: "absolute",
                  top: "0",
                  right: "0px",
                  height: "35px",
                  width: "45px",
                  // top: "49% !important",
                  borderTopLeftRadius: "0",
                  borderBottomLeftRadius: "0",
                  // transform: "translateY(-60%)"
                }}
                onClick={getRegistrationListBySearch}
                disabled={SearchLoading}
              >
                <FaSearch />
                {/* <span className="ms-2 d-md-none">Search</span> */}
              </button>
            </div>
          </div>
        </div>

        <div>
          <div className="table-responsive">
            <table className="table table-bordered custom-table">
              <thead>
                <tr>
                  <th style={{ width: "7%" }}> Partner Code </th>
                  <th style={{ width: "17%" }}> TRF ID </th>
                  <th style={{ width: "7%" }}> Created On </th>
                  <th style={{ width: "8%" }}> TRF Generated </th>
                  <th style={{ width: "5%" }}> TRF Req </th>
                  <th style={{ width: "5%" }}> TRF Res </th>
                  <th style={{ width: "5%" }}> RNI </th>
                  <th style={{ width: "5%" }}> RNI Req </th>
                  <th style={{ width: "5%" }}> RNI Res </th>
                  <th style={{ width: "8%" }}> Registration </th>
                  <th style={{ width: "5%" }}> Action </th>
                </tr>
              </thead>

              <tbody
                style={{ fontSize: "0.5rem" }}
                className="patient-list-small-font"
              >
                {currentRegistrations?.length === 0 ? (
                  <tr>
                    <td colSpan="11" className="text-center">
                      No registrations found
                    </td>
                  </tr>
                ) : (
                  currentRegistrations.map((rec) => (
                    <tr className="patient-list-row" key={rec.Trf_Status_Id}>
                      {/* Partner Code */}
                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {rec?.Partner_Code || "-"}
                      </td>

                      {/* TRF ID */}
                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {rec?.Trf_Id || "-"}
                      </td>

                      {/* Created On */}
                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {formatVisitDate(rec?.Created_On)}
                      </td>

                      {/* TRF Generated */}
                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {!rec?.Is_Trf_Generated && (
                          <Popover
                            content={
                              <div
                                style={{ textAlign: "left", maxWidth: "250px" }}
                              >
                                {rec.Trf_Error_Message}
                              </div>
                            }
                            placement="right"
                          >
                            <FaInfoCircle
                              color="green"
                              size={13}
                              style={{ cursor: "pointer", marginBottom: "2px" }}
                            />
                          </Popover>
                        )}
                        &nbsp;
                        {rec?.Is_Trf_Generated ? "True" : "False"}
                      </td>

                      {/* View JSON */}
                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        <button
                          className="btn btn-sm elmaherrorxmlicon"
                          title="View TRF Request"
                          style={{
                            borderRadius: "5px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                          // onClick={() =>
                          //   openModal(
                          //     rec?.Trf_Req,
                          //     "Trf_Req",
                          //     rec.Trf_Status_Id,
                          //   )
                          // }
                          onClick={() => {
                            openModal(
                              rec?.Trf_Req,
                              "Trf_Req",
                              "VIEW",
                              rec.Trf_Status_Id,
                            );
                            // setTrfReq(rec?.Trf_Req);
                          }}
                        >
                          <FaFileCode size={14} />
                        </button>
                      </td>

                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        <button
                          className="btn btn-sm elmaherrorxmlicon"
                          title={`View TRF Response`}
                          style={{
                            borderRadius: "5px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer !important",
                          }}
                          onClick={() =>
                            openModal(rec?.Trf_Res, "Trf_Res", "VIEW")
                          }
                        >
                          <FaFileCode size={14} />
                        </button>
                      </td>

                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {!rec?.Is_Registration && (
                          <Popover
                            content={
                              <div
                                style={{ textAlign: "left", maxWidth: "250px" }}
                              >
                                {rec.Rni_Error_Message}
                              </div>
                            }
                            placement="right"
                          >
                            <FaInfoCircle
                              color="green"
                              size={13}
                              style={{ cursor: "pointer", marginBottom: "2px" }}
                            />
                          </Popover>
                        )}
                        &nbsp;
                        {rec?.Is_Registration ? "True" : "False"}
                      </td>

                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        <button
                          className="btn btn-sm elmaherrorxmlicon"
                          title={`View RNI Request`}
                          style={{
                            borderRadius: "5px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer !important",
                          }}
                          onClick={() => {
                            openModal(
                              rec?.Rni_Req,
                              "Rni_Req",
                              "VIEW",
                              rec.Trf_Status_Id,
                            );
                            // setRniReq(rec?.Rni_Req);
                          }}
                        >
                          <FaFileCode size={14} />
                        </button>
                      </td>

                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        <button
                          className="btn btn-sm elmaherrorxmlicon"
                          title={`View RNI Response`}
                          style={{
                            borderRadius: "5px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer !important",
                          }}
                          onClick={() =>
                            openModal(rec?.Rni_Res, "Rni_Res", "VIEW")
                          }
                        >
                          <FaFileCode size={14} />
                        </button>
                      </td>

                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {rec?.Is_B2B_Registration_Success
                          ? "Success"
                          : "Failed"}
                      </td>

                      {/* Action */}
                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        <div className="d-flex align-items-center justify-content-center gap-2">
                          <button
                            title="View TRF Details"
                            style={{
                              transition: "transform 0.2s",
                              padding: 0,
                              border: "none",
                            }}
                            className="btn d-flex"
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.transform = "scale(1.2)")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.transform = "scale(1)")
                            }
                          >
                            <Eye
                              color="green"
                              className="d-flex"
                              onClick={() => {
                                GetB2BTRFRegistrationDetailByTRFId(rec?.Trf_Id);
                                setSelectedTrfStatusId(rec?.Trf_Status_Id);
                                setTrfReq(rec?.Trf_Req);
                                setRniReq(rec?.Rni_Req);
                              }}
                            />
                          </button>

                          <button
                            title="Retry Registration"
                            disabled={
                              SearchLoading || rec.Is_B2B_Registration_Success
                            }
                            style={{
                              transition: "transform 0.2s",
                              padding: 0,
                              border: "none",
                            }}
                            className="btn"
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.transform = "scale(1.2)")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.transform = "scale(1)")
                            }
                          >
                            <FaPaperPlane
                              className="d-flex"
                              onClick={() =>
                                RepushFailedRegistration(rec.Trf_Id)
                              }
                              style={{
                                cursor: "pointer",
                              }}
                              color="green"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {registrationStatusList.length > itemsPerPage ? (
            <CommonPagination
              pageList={registrationStatusList}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
            />
          ) : null}
        </div>
      </CommonContainer>

      {showPreview && b2bTRFRegistrationDetails && (
        <>
          <div className="modal-backdrop"> </div>
          <div
            className="modal fade show d-block success"
            tabIndex="-1"
            // style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header custom-card-heading text-white p-2">
                  <h5 className="modal-title text-white px-2">
                    Patient TRF Details ({b2bTRFRegistrationDetails.Reg_Trf_Id})
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white mr-1"
                    onClick={() => setShowPreview(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  {/* Patient Details */}
                  <h6 className="mb-2">
                    <strong>Patient Details</strong>
                  </h6>
                  <div className="row">
                    <div
                      className="col-md-6"
                      style={{ borderRight: "1px solid #ccc" }}
                    >
                      <p>
                        <strong>Name:</strong>{" "}
                        {b2bTRFRegistrationDetails.Patient_Details?.Salutation}{" "}
                        {b2bTRFRegistrationDetails.Patient_Details?.First_Name}{" "}
                        {b2bTRFRegistrationDetails.Patient_Details?.Middle_Name}{" "}
                        {b2bTRFRegistrationDetails.Patient_Details?.Last_Name}
                      </p>
                      <p>
                        <strong>Gender:</strong>{" "}
                        {b2bTRFRegistrationDetails.Patient_Details?.Gender}
                      </p>
                      <p>
                        <strong>DOB:</strong>{" "}
                        {b2bTRFRegistrationDetails.Patient_Details?.Dob
                          ? new Date(
                              b2bTRFRegistrationDetails.Patient_Details.Dob,
                            ).toLocaleDateString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })
                          : "-"}
                      </p>
                      <p>
                        <strong>Patient History:</strong>{" "}
                        {b2bTRFRegistrationDetails.Patient_History ? (
                          (() => {
                            const historyItems =
                              b2bTRFRegistrationDetails.Patient_History.split(
                                ",",
                              )
                                .map((x) => x.trim())
                                .filter((x) => x);
                            if (historyItems.length === 0)
                              return (
                                <span className="text-muted">No history</span>
                              );
                            if (historyItems.length === 1)
                              return <span>{historyItems[0]}</span>;
                            return (
                              <Popover
                                content={
                                  <ul className="list-unstyled m-0 p-1">
                                    {historyItems.map((item, i) => (
                                      <li key={i}>{item}</li>
                                    ))}
                                  </ul>
                                }
                              >
                                <span style={{ cursor: "pointer" }}>
                                  {historyItems[0]} +{historyItems.length - 1}
                                </span>
                              </Popover>
                            );
                          })()
                        ) : (
                          <span className="text-muted">Not Provided</span>
                        )}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong>Mobile:</strong>{" "}
                        {b2bTRFRegistrationDetails.Patient_Details
                          ?.Mobile_Number || (
                          <span className="text-muted">Not Provided</span>
                        )}
                      </p>
                      {/* <p><strong>Email:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Email || <span className="text-muted">Not Provided</span>}</p> */}
                      {/* <p><strong>Dr. Name:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Doctor_Name || <span className="text-muted">Not Provided</span>}</p> */}
                      <p>
                        <strong>Remarks:</strong>{" "}
                        {b2bTRFRegistrationDetails.Remarks ? (
                          b2bTRFRegistrationDetails.Remarks.length > 40 ? (
                            <Popover
                              content={
                                <div
                                  style={{
                                    maxWidth: "300px",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {b2bTRFRegistrationDetails.Remarks}
                                </div>
                              }
                            >
                              <span
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                              >
                                {b2bTRFRegistrationDetails.Remarks.slice(0, 40)}
                                ...
                              </span>
                            </Popover>
                          ) : (
                            b2bTRFRegistrationDetails.Remarks
                          )
                        ) : (
                          <span className="text-muted">Not Provided</span>
                        )}
                      </p>
                    </div>
                  </div>

                  {/* Patient Attachments */}
                  <div className="row mt-2">
                    <div className="col-md-12 d-flex align-items-center">
                      <strong>Patient Attachments:</strong>&nbsp;
                      {b2bTRFRegistrationDetails.Patient_Attachments &&
                      b2bTRFRegistrationDetails.Patient_Attachments.length >
                        0 ? (
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowAttachments(true);
                          }}
                          className="text-primary"
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          View Uploaded Attachments (
                          {b2bTRFRegistrationDetails.Patient_Attachments.length}
                          )
                        </a>
                      ) : (
                        <span className="text-muted">
                          No patient attachments uploaded.
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Test Details */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <h6>
                      <strong>Lab Investigations</strong> (
                      {b2bTRFRegistrationDetails.Patient_Tests?.length || 0})
                    </h6>
                    <span>
                      <strong>Sample Date/Time: </strong>
                      {b2bTRFRegistrationDetails.Sample_Collection_Datetime &&
                        new Date(
                          b2bTRFRegistrationDetails.Sample_Collection_Datetime,
                        )
                          .toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                          .replace(",", "")
                          .replace(/\s?(am|pm)/i, (m) => m.toUpperCase())}
                    </span>
                  </div>

                  <div
                    style={{ maxHeight: "150px", overflowY: "auto" }}
                    className="table-responsive-trf-summary mb-2"
                  >
                    <table className="table table-bordered custom-table mb-1">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "35%" }}>Test Name (Code)</th>
                          {/* <th>Code</th> */}
                          <th>Test TAT</th>
                          <th style={{ width: "20%" }}>Test Remarks</th>
                          {/* <th>Type</th> */}
                          <th>Processing Location</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="trf-detail-list-small-font">
                        {b2bTRFRegistrationDetails.Patient_Tests?.length > 0 ? (
                          b2bTRFRegistrationDetails.Patient_Tests.map(
                            (test, idx) => (
                              <tr key={idx}>
                                <td
                                  className="text-left align-middle"
                                  style={{
                                    width: "35%",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {test.Test_Name} (<b>{test.Test_Code}</b>)
                                </td>
                                <td>
                                  {CommonVariables.formatUTCToIST(
                                    test.Test_Tat,
                                  )}
                                </td>
                                <td>
                                  {test.Remarks ? (
                                    test.Remarks.length > 20 ? (
                                      <Popover
                                        content={
                                          <div
                                            style={{
                                              maxWidth: "300px",
                                              wordWrap: "break-word",
                                            }}
                                          >
                                            {test.Remarks}
                                          </div>
                                        }
                                      >
                                        <span style={{ cursor: "pointer" }}>
                                          {test.Remarks.slice(0, 20)}...
                                        </span>
                                      </Popover>
                                    ) : (
                                      test.Remarks
                                    )
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  {" "}
                                  {test.Processing_Location && (
                                    <>
                                      {test.Processing_Location.includes(
                                        ",",
                                      ) ? (
                                        <Popover
                                          content={
                                            <ul
                                              className="list-unstyled"
                                              style={{
                                                textAlign: "left",
                                                paddingLeft: "2px",
                                                margin: 0,
                                              }}
                                            >
                                              {test.Processing_Location.split(
                                                ",",
                                              ).map((loc, index) => (
                                                <li key={index}>
                                                  {loc.trim()}
                                                </li>
                                              ))}
                                            </ul>
                                          }
                                        >
                                          <span style={{ cursor: "pointer" }}>
                                            {
                                              test.Processing_Location.split(
                                                ",",
                                              )[0]
                                            }{" "}
                                            (+
                                            {test.Processing_Location.split(",")
                                              .length - 1}
                                            )
                                          </span>
                                        </Popover>
                                      ) : (
                                        test.Processing_Location
                                      )}
                                    </>
                                  )}
                                </td>
                                <td className="text-center">
                                  {test.Is_Required_History ? (
                                    <div
                                      title="View Document"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setSelectedTest(test);
                                        setShowHistoryModal(true);
                                      }}
                                    >
                                      <FaEye color="green" size={19} />
                                    </div>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                              </tr>
                            ),
                          )
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center">
                              No tests found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Patient Test Samples */}
                  <h6 className="mt-3 mb-2">
                    <strong>Investigations Container & Samples</strong> (
                    {b2bTRFRegistrationDetails.Patient_Test_Samples?.length ||
                      0}
                    )
                  </h6>
                  <div
                    style={{ maxHeight: "150px", overflowY: "auto" }}
                    className="table-responsive-trf-summary mb-2"
                  >
                    <table className="table table-bordered custom-table">
                      <thead className="table-light">
                        <tr>
                          <th>Container Name</th>
                          <th>Sample Name</th>
                          {userDetails?.Is_Avail_For_PrePrintedBarcode && (
                            <th>Barcode</th>
                          )}
                          <th>Processing Location</th>
                        </tr>
                      </thead>
                      <tbody className="trf-detail-list-small-font">
                        {b2bTRFRegistrationDetails.Patient_Test_Samples &&
                        b2bTRFRegistrationDetails.Patient_Test_Samples.length >
                          0 ? (
                          b2bTRFRegistrationDetails.Patient_Test_Samples.map(
                            (sample, i) => (
                              <tr key={i}>
                                <td>{sample.Container_Name}</td>
                                <td>{sample.Sample_Name}</td>
                                {userDetails?.Is_Avail_For_PrePrintedBarcode && (
                                  <td>{sample.Barcode_Id}</td>
                                )}
                                <td>{sample.Processing_Location}</td>
                              </tr>
                            ),
                          )
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No samples found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                
                {userDetails.Role_Name === "Admin" &&
                 <div className="modal-footer p-2">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => setShowPreview(false)}
                  >
                    Close
                  </button>
                  <button
                    className="btn custom-sumbitbtn"
                    onClick={() =>
                      openModal(
                        trfReq,
                        "Trf_Req",
                        "EDIT_TRF",
                        selectedTrfStatusId,
                      )
                    }
                  >
                    Edit TRF Req
                  </button>

                  <button
                    className="btn custom-sumbitbtn"
                    onClick={() =>
                      openModal(
                        rniReq,
                        "Rni_Req",
                        "EDIT_RNI",
                        selectedTrfStatusId,
                      )
                    }
                  >
                    Edit RNI Req
                  </button>
                </div>
                }
               
              </div>
            </div>
          </div>
        </>
      )}

      {isModalOpen && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={closeModal}
        >
          <div
            className="modal-dialog modal-xl modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content" style={{ maxHeight: "90vh" }}>
              <div className="modal-header">
                <h5 className="modal-title">JSON</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>

              <div
                className="modal-body"
                style={{
                  ...(editorMode !== "VIEW" && {
                    overflowY: "auto",
                    maxHeight: "70vh",
                  }),
                  backgroundColor: "#f8f9fa",
                  padding: "15px",
                  border: "1px solid #ddd",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  fontFamily: "monospace",
                  fontSize: "12px",
                }}
              >
                {/* <Editor
                  height="70vh"
                  defaultLanguage="json"
                  value={modalContent}
                  onChange={(value) => setModalContent(value)}
                  options={{
                    minimap: { enabled: false },
                    fontSize: 13,
                    wordWrap: "on",
                    automaticLayout: true,
                    formatOnPaste: true,
                    formatOnType: true,
                  }}
                /> */}

                <Editor
                  height="70vh"
                  // key={`${editorMode}-${selectedTrfStatusId}`}
                  language="json"
                  value={modalContent}
                  onChange={(value) => setModalContent(value || "")}
                  options={{
                    readOnly: editorMode === "VIEW",
                    minimap: { enabled: false },
                    fontSize: 13,
                    wordWrap: "on",
                    automaticLayout: true,
                    formatOnPaste: true,
                    // formatOnType: editorMode !== "VIEW",
                  }}
                />
              </div>

              {(editorMode === "EDIT_TRF" || editorMode === "EDIT_RNI") && (
                <div className="modal-footer">
                  <button className="btn btn-danger" onClick={closeModal}>
                    Close
                  </button>

                  <button
                    className="btn custom-sumbitbtn"
                    onClick={handleSave}
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save"}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {showAttachments && (
        <div className="modal-backdrop w-100">
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-l" role="document">
              <div className="modal-content">
                <div className="modal-header p-2 ml-1">
                  <h5 className="modal-title">Patient Attachement</h5>
                  <button
                    type="button"
                    className="btn-close mr-1"
                    onClick={() => setShowAttachments(false)}
                  ></button>
                </div>
                <div
                  className="modal-body"
                  style={{ maxHeight: "60vh", overflowY: "auto" }}
                >
                  <ul className="list-group small">
                    {b2bTRFRegistrationDetails.Patient_Attachments.map(
                      (att, idx) => (
                        <li
                          className="list-group-item uploaded-docs-list-item d-flex justify-content-between align-items-center"
                          key={idx}
                        >
                          <span
                            className="px-2"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {att.Urn_Of && <b>{att.Urn_Of.charAt(0)}</b>}
                            {att.Urn_Of ? " - " : ""}
                            {att.Urn_File_Type}
                            {att.Urn_Number ? ` (${att.Urn_Number})` : ""}
                          </span>
                          {/* <span className="px-2" style={{ whiteSpace: "nowrap" }}><b>{att.Urn_Of?.charAt(0)}</b> - {att.Urn_File_Type} ({att.Urn_Number})</span>        */}
                          <div className="d-flex align-items-center">
                            <div
                              title="View Document"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleAttachmentDownload(att.Urn_File_Path)
                              }
                              className="view-doc-btn-wrapper"
                            >
                              <FaEye color="green" size={19} />
                            </div>
                          </div>
                        </li>
                      ),
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showHistoryModal && selectedTest && (
        <>
          <div className="modal-backdrop"></div>
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-l" role="document">
              <div className="modal-content">
                <div className="modal-header p-2 ml-1">
                  <h5 className="modal-title">
                    History - {selectedTest.Test_Name} ({selectedTest.Test_Code}
                    )
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => {
                      setShowHistoryModal(false);
                      setSelectedTest(null);
                    }}
                  ></button>
                </div>

                <div
                  className="modal-body"
                  style={{ maxHeight: "65vh", overflowY: "auto" }}
                >
                  {selectedTest.History_Attributes?.length > 0 ? (
                    <div className="row g-2">
                      {selectedTest.History_Attributes.map((att, idx) => (
                        <div key={idx} className="col-12">
                          <div className="card shadow-sm border rounded p-2">
                            <div className="d-flex flex-column">
                              {/* Name */}
                              <div className="d-flex align-items-center mb-1">
                                <span className="fw-bold me-1">Name:</span>
                                <span>{att.History_Name}</span>
                              </div>

                              {/* VALUE FOR NON-ATTACHMENTS */}
                              {att.History_Attribute !== "Attachement" ? (
                                <div className="d-flex align-items-center">
                                  <span className="fw-bold me-1">Value:</span>
                                  <span className="text-muted">
                                    {att.History_Value || "—"}
                                  </span>
                                </div>
                              ) : (
                                /* ATTACHMENTS LIST WITH FILETYPE GROUPING */
                                <>
                                  {(() => {
                                    const typeCounters = {}; // Counter holder

                                    return (
                                      <ul className="list-group small mt-1">
                                        {att.HistoryAttachments?.length > 0 ? (
                                          att.HistoryAttachments.map(
                                            (attachment, aidx) => {
                                              // increase counter for current fileType
                                              if (
                                                !typeCounters[
                                                  attachment.fileType
                                                ]
                                              ) {
                                                typeCounters[
                                                  attachment.fileType
                                                ] = 1;
                                              } else {
                                                typeCounters[
                                                  attachment.fileType
                                                ]++;
                                              }

                                              const displayIndex =
                                                typeCounters[
                                                  attachment.fileType
                                                ];

                                              return (
                                                <li
                                                  key={aidx}
                                                  className="list-group-item uploaded-docs-list-item d-flex justify-content-between align-items-center"
                                                >
                                                  <span
                                                    className="px-2"
                                                    style={{
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    <b>
                                                      {attachment.fileType?.charAt(
                                                        0,
                                                      )}
                                                    </b>{" "}
                                                    - {attachment.fileType} |
                                                    Attachment {displayIndex}
                                                  </span>

                                                  <div className="d-flex align-items-center gap-2">
                                                    <div
                                                      title="View Document"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        handleAttachmentDownload(
                                                          attachment.filePath,
                                                        )
                                                      }
                                                      className="view-doc-btn-wrapper"
                                                    >
                                                      <FaEye
                                                        color="green"
                                                        size={18}
                                                      />
                                                    </div>
                                                  </div>
                                                </li>
                                              );
                                            },
                                          )
                                        ) : (
                                          <li className="list-group-item text-muted">
                                            No attachments available
                                          </li>
                                        )}
                                      </ul>
                                    );
                                  })()}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-center text-muted mb-0">
                      No history data available for this test.
                    </p>
                  )}
                </div>

                <div className="modal-footer p-2">
                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      setShowHistoryModal(false);
                      setSelectedTest(null);
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RegistrationStatusComponent;
